import React from 'react';
import { Layout, Row, Col, Typography, Divider, Space } from 'antd';
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';

const { Footer: AntFooter } = Layout;
const { Title, Text, Link } = Typography;

const Footer: React.FC = () => {
  return (
    <AntFooter className="dasoon-footer">
      <div className="container mx-auto">
        <Row gutter={[32, 32]}>
          <Col xs={24} sm={12} md={6}>
            <div className="mb-4">
              <img 
                src="/images/dasoon-logo.png" 
                alt="Dasoon" 
                className="dasoon-logo mb-3"
                style={{ height: '60px', width: 'auto' }}
              />
            </div>
            <Text className="dasoon-text-gray" style={{ display: 'block', marginBottom: '16px' }}>
              Welcome to the official Dasoon site.
            </Text>
            <Text className="dasoon-text-gray">
              We are an importer and wholesaler of all egg products.
            </Text>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <Title level={4} className="dasoon-text-white">
              Contact Info
            </Title>
            <div style={{ marginTop: '24px' }}>
              <div style={{ marginBottom: '16px' }}>
                <EnvironmentOutlined style={{ color: 'var(--dasoon-primary)', marginRight: '8px' }} />
                <Text className="dasoon-text-gray" style={{ fontWeight: 500 }}>
                  HQ: 96 Jalan Jurong Kechil<br />
                  Singapore 598599
                </Text>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <EnvironmentOutlined style={{ color: 'var(--dasoon-primary)', marginRight: '8px' }} />
                <Text className="dasoon-text-gray" style={{ fontWeight: 500 }}>
                  Warehouse: 12 Wan Lee Road<br />
                  Singapore 627944
                </Text>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <PhoneOutlined style={{ color: 'var(--dasoon-primary)', marginRight: '8px' }} />
                <Text className="dasoon-text-gray">+65 6469 9891</Text>
              </div>
              <div>
                <MailOutlined style={{ color: 'var(--dasoon-primary)', marginRight: '8px' }} />
                <Text className="dasoon-text-gray">kaijun@lianfong.com.sg</Text>
              </div>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <Title level={4} className="dasoon-text-white">
              Subscribe
            </Title>
            <div style={{ marginTop: '24px' }}>
              <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <input 
                  type="email" 
                  placeholder="Your Email..." 
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid var(--dasoon-text-gray)',
                    backgroundColor: 'var(--dasoon-bg-darker)',
                    color: 'var(--dasoon-text-gray)',
                    fontFamily: 'var(--font-main)'
                  }}
                />
                <button 
                  className="dasoon-btn-primary"
                  style={{
                    width: '100%',
                    padding: '12px 20px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontFamily: 'var(--font-main)',
                    fontWeight: 500
                  }}
                >
                  Subscribe
                </button>
              </Space>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={6}>
            <div style={{ textAlign: 'center' }}>
              <img 
                src="/images/dasoon-halal-logo.png" 
                alt="Halal Certified" 
                style={{ 
                  height: '80px', 
                  width: 'auto',
                  marginBottom: '16px'
                }}
              />
              <Text className="dasoon-text-gray" style={{ display: 'block', fontSize: '14px' }}>
                Halal Certified Products
              </Text>
            </div>
          </Col>
        </Row>
        
        <Divider style={{ borderColor: 'var(--dasoon-text-gray)', margin: '32px 0' }} />
        
        <div style={{ textAlign: 'center' }}>
          <Text className="dasoon-text-gray">
            © {new Date().getFullYear()} Dasoon. All rights reserved.
          </Text>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;